import { useSignal } from "@preact/signals-react";
import { Outlet } from "react-router";

import Sidebar from "./Sidebar";
import Navbar from "pages/Dash/Navbar";
import FullScreenLoading from "components/Tools/FullScreenLoading";
import { Bars3Icon, XMarkIcon } from "components/Icons";
import { cn } from "tools/ui";
import useMediaQuery from "hooks/useMediaQuery";
import logo from "assets/img/logo.png";

function Dash(props) {
  // Phone/tablet (<1024) start with the drawer closed; desktop keeps the rail.
  const openSidebar = useSignal(
    window.matchMedia("(min-width: 1024px)").matches,
  );
  const { menusDash } = props;
  const viewportHeight = window.innerHeight - 64;
  const isDesktop = useMediaQuery("(min-width: 1024px)");

  function handleSidebar() {
    openSidebar.value = !openSidebar.value;
  }

  // Desktop: open = collapsed rail. Phone/tablet: open = menu visible.
  const showClose = isDesktop ? !openSidebar.value : openSidebar.value;
  const IconDash = !showClose ? (
    < Bars3Icon className="size-7 md:h-8 md:w-8 fill-white " />
  ) : (
    <XMarkIcon className="size-10  fill-white" />
  );

  if (!menusDash) {
    return <FullScreenLoading message="Cargando aplicaciones..." />;
  }

  return (
    <div id="dash" className="h-fit w-full z-auto">
      <header className="overflow-visible sticky top-0 flex columns-2 bg-neutral-800 h-16 w-full z-30">
        <div className="h-full w-1/2 hover:opacity-70 hover:cursor-pointer flex">
          <button
            type="button"
            className="px-4 md:px-5"
            onClick={handleSidebar}
            aria-label={showClose ? "Cerrar menú" : "Abrir menú"}
          >
            {IconDash}
          </button>
          <img
            className="mx-0 md:mx-3 my-auto h-full object-contain"
            src={logo}
            width={140}
            alt="logo"
          />
        </div>
        <Navbar routes={menusDash} />
      </header>
      <main
        id="dash"
        className={cn(
          "flex flex-col lg:flex-row tablet:h-[calc(100vh-64px)]",
          openSidebar.value
            ? "max-[599px]:h-[calc(100vh-64px)] max-[599px]:overflow-hidden"
            : "",
        )}
      >
        <Sidebar
          {...props}
          isDesktop={isDesktop}
          routes={menusDash}
          openSidebar={openSidebar}
          viewportHeight={viewportHeight}
        />
        {openSidebar.value && (
          <div
            aria-hidden="true"
            onClick={handleSidebar}
            className="hidden tablet:block lg:hidden fixed inset-0 top-16 z-30 bg-black/40"
          />
        )}
        <div
          id="outlet"
          className="flex pt-2 bg-neutral-100 w-full overflow-auto max-md:relative flex-1"
        >
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default Dash;
